<template>
  <footer id="global-footer">
    <div class="divider"></div>
    <div class="container">
      <div class="row">
        <div>
          <div class="copyright">
            <p class="bei">© 2020-2031 上海星笙科技有限公司 版权所有</p>
            <p class="bei">增值电信业务经营许可证: 沪B2-20211387</p>
            <a href="https://beian.miit.gov.cn" class="bei" target="_blank">ICP备案号: 沪ICP备 2021017234号-3</a>
          </div>
        </div>
      </div>

    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer"
}
</script>

<style scoped>

</style>
